import Header, { HeaderLeft } from "../../../layout/Header/Header";
import CommonHeaderRight from "./CommonHeaderRight";

const BillingCyclesHeader = () => {
  return (
    <Header>
      <HeaderLeft>
        <div>
          <div className="fw-bold fs-6 mb-0">Billing Cycles</div>
          <div className="text-muted">
            <small>
              Setup Billing Cycles.
            </small>
          </div>
        </div>
      </HeaderLeft>
      <CommonHeaderRight />
    </Header>
  );
};

export default BillingCyclesHeader;
